new Swiper('.custom-banner-swiper', {
     loop: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false
      },
      speed: 800,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      allowTouchMove: true,
    });